import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

// Import the separate reducers
import loginReducer from "./slices/auth/LoginSlice";
import signupReducer from "./slices/auth/SignupSlice";
import passwordReducer from "./slices/auth/PasswordSlice";
import routesReducer from "./slices/common-slice/route/RouteSlice";
import contactReducer from "./slices/common-slice/contact/ContactSlice";
import searchLocationReducer from "./slices/common-slice/location/SearchLocationSlice";
import productReducer from "./slices/common-slice/products/ProductSlice";
import sellerCampaignsReducer from "./slices/seller-slice/campaigns/campaignSlice";
import buyerCampaignReducer from "./slices/buyer-slice/campaigns/buyerCampaignsSlice";
import rfpReducer from "./slices/common-slice/rfp/rfpSlice";
import userProfileReducer from "./slices/auth/UserProfileSlice";
import airecommendedReducer from "./slices/buyer-slice/airecommended/AiRecommendedSlice";
import campaigncartReducer from "./slices/buyer-slice/campaigncart/CampaignsCartSlice";
import advertisementReducer from "./slices/auth/AdvertisementSlice";
import billboardEnquiryReducer from "./slices/auth/BillboardEnquirySlice";
import submitRfpReducer from "./slices/auth/SubmitRFPSlice";
import pricingModuleReducer from "./slices/common-slice/pricing/PricingModuleSlice";
import grossFeeReducer from "./slices/buyer-slice/grossfee/GrossFee";
import offerPriceReducer from "./slices/buyer-slice/offerprice/OfferPrice";
import campaignPurchaseReducer from "./slices/buyer-slice/campaigns-purchse-slice/CampaignPurchaseSlice";
import chatBotReducer from "./slices/chat-bot/ChatBotSlice";
import dmaReducer from "./slices/common-slice/dma-reducer/DmaReducerSlice";
import filterReducer from "./slices/common-slice/product-filters/ProductFilter";
import termsCamapignReducer from "./slices/buyer-slice/terms-campaign-manipulations/CampaignTermsSlice";
import termsUserActionReducer from "./slices/buyer-slice/terms-user-action-slice/TermsUserActionSlice";
import buyerPaymentReducer from "./slices/buyer-slice/billingPayments/BillingPaymentsSlice";
import notificationReducer from "./slices/common-slice/notifications/NotificationSlice";
import buyerDashboardReducer from "./slices/buyer-slice/dashboard/dashboardSlice";
import readcrumbReducer from "./slices/common-slice/bread-crumbs/BreadCrumbSlice";
import sellerTermsReducer from "./slices/seller-slice/termsRequestsSlice/TermsRequestSlice";
import docuSignReducer from "./slices/buyer-slice/docu-sign-slice/DocuSignSlice";
import productDetailsReducer from "./slices/common-slice/product-details-action-items/productDetailsActionItemslice";
import chatCommunicationHandleReducer from "./slices/common-slice/chat-communication/ChatCommunicationActionItems";
import webSocketMsgsReducer from "./slices/common-slice/web-sockets/WebSocketMsgSlice";
import adsListReducer from "./slices/ads-slice/AdsSlice";
import chatHistoryReducer from "./slices/common-slice/chat-communication/ChatHistorySlice";
import newChatBotSchema from "./slices/chat-bot/NewChatBotSchemaSlice";
import productHoldRequestsReducer from "./slices/buyer-slice/product-hold-request/ProductHoldRequest";
import defaultTermsBookingSliceReducer from "./slices/buyer-slice/default-terms-booking-status/DefaultTermsBookingStatusSlice";
import negotiationTermsReducer from "./slices/common-slice/all-negotiation-slice/NegotiationTermsStatusSlice";
import rfpRefreshedProductsReducer from "./slices/buyer-slice/rfp-refreshed-products/RfpRefreshedProducts";
const rootReducer = combineReducers({
  login: loginReducer,
  signup: signupReducer,
  password: passwordReducer,
  route: routesReducer,
  contact: contactReducer,
  location: searchLocationReducer,
  products: productReducer,
  sellerCampaigns: sellerCampaignsReducer,
  buyerCampaigns: buyerCampaignReducer,
  rfp: rfpReducer,
  userprofile: userProfileReducer,
  airecommendations: airecommendedReducer,
  campaignscart: campaigncartReducer,
  advertisement: advertisementReducer,
  billboardEnquiry: billboardEnquiryReducer,
  submitrfp: submitRfpReducer,
  pricingModule: pricingModuleReducer,
  grossfee: grossFeeReducer,
  offerPrice: offerPriceReducer,
  campaignpurchase: campaignPurchaseReducer,
  chatBot: chatBotReducer,
  dma: dmaReducer,
  filters: filterReducer,
  termsCampaign: termsCamapignReducer,
  payment: termsUserActionReducer,
  buyerPayments: buyerPaymentReducer,
  buyerDashboard: buyerDashboardReducer,
  notifications: notificationReducer,
  breadcrumb: readcrumbReducer,
  sellerterms: sellerTermsReducer,
  docuSign: docuSignReducer,
  productDetailsSlice: productDetailsReducer,
  chatCommunicationHandleSlice: chatCommunicationHandleReducer,
  webSocketMsgs: webSocketMsgsReducer,
  ads: adsListReducer,
  chatHistory: chatHistoryReducer,
  newChatSchema: newChatBotSchema,
  productHoldRequest: productHoldRequestsReducer,
  defaultBookingTerms: defaultTermsBookingSliceReducer,
  negotiationTerms: negotiationTermsReducer,
  rfpRefreshedProducts: rfpRefreshedProductsReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["login", "filters", "dma", "breadcrumb"], // Add other slices you want to persist
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
